import { motion } from "framer-motion";
import { Factory, Flame, Shirt, FlaskConical, Hotel, Zap } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const APPS = [
  { icon: Factory, label: "Industrial Boilers" },
  { icon: Flame, label: "Brick Kilns" },
  { icon: Shirt, label: "Textile Mills" },
  { icon: FlaskConical, label: "Chemical Plants" },
  { icon: Hotel, label: "Hotels & Commercial Kitchens" },
  { icon: Zap, label: "Power Generation Plants" },
];

export const Applications = () => (
  <section id="applications" data-testid="applications-section" className="py-20 lg:py-32">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <Eyebrow>Where Our Pellets Work</Eyebrow>
        <h2 className="font-display mt-4 max-w-2xl text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl" data-testid="applications-heading">
          Bio Pellet Applications
        </h2>
        <p className="mt-4 max-w-2xl text-base text-slate-400">
          One clean fuel, engineered for every industrial heat requirement.
        </p>
      </Reveal>

      <div className="mt-12 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:gap-6">
        {APPS.map((a, i) => (
          <motion.div
            key={a.label}
            data-testid={`application-card-${i}`}
            initial={{ opacity: 0, scale: 0.94 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: (i % 3) * 0.08, ease: [0.16, 1, 0.3, 1] }}
            className="group flex flex-col items-center gap-4 rounded-2xl border border-emerald-500/15 bg-[#0B150F] px-4 py-10 text-center transition-all duration-300 hover:border-emerald-500/50 hover:bg-[#101F16]"
          >
            <a.icon className="h-9 w-9 text-emerald-400 transition-transform duration-300 group-hover:scale-110" />
            <span className="font-display text-sm font-bold tracking-wide text-white sm:text-base">{a.label}</span>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
